import {
  Box, Button, Container, Grid, IconButton, InputBase, Pagination, Paper,
  Stack, TableBody, Table, TableContainer, TableHead, TableRow, FormControl,
  InputLabel, Select, MenuItem, Backdrop, CircularProgress, createTheme,
  ThemeProvider, TextField, InputAdornment, Divider, Typography, Accordion,
  AccordionSummary, AccordionDetails
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { IPays, StyledTableCell, tableStyle } from "../Pays/Pays";
import { useContext, useEffect, useState } from "react";
import axios, { AxiosInstance } from "axios";
import { DataRef } from "../../../../types/DataRef";
import Cookies from "universal-cookie";
import {
  ClientWithChildInterface, DeviseInterface, tableColumnTittlesArticle
} from "./InterfaceArticle";
import ArticleRow from "./ArticleRow";
import TabSort from "../../../element/sort/TabSort";
import { SortParams } from "../../production/SaisieAgent";
import { AlertType, SortType } from "../../../../types/AlertType";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { urlApi } from "../Pays/RowPays";
import ArticleForm from "../../../forms/article/ArticleForm";
import { useDispatch, useSelector } from "react-redux";
import { Reducers } from "../../../../redux/reducers";
import ArticleInformation from "../../../../types/ArticleInformation";
import { deleteArticleInformationParam } from "../../../../redux/actions/articleParam";
import CheckAttr from "../../../../utils/CheckAttr";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import { SnackBarAlert } from "../../../element/SnackBarAlert";
import ClearIcon from "@mui/icons-material/Clear";
import { loggoutUser } from "../../../../redux/actions/logginUser";
import { useNavigate } from 'react-router-dom';
import { MediaQueryContext } from "../../../../utils/contextes/MediaQueryContext";

export interface FirstNiveau {
  pivot_oper_socifact_id: number;
  piv_socifact_code_id: number;
  operation_id: number;
  operation_libelle: string;
  societe_id: number;
  societe_libelle: string;
  code_gesco_id: number;
  code_gesco_libelle: string;
  client_id: number;
  client_libelle: string;
}

export interface SecondNiveau {
  id: number;
  libelle: string;
  actif: boolean;
  semi_automatique: boolean;
  type_id: number;
  type_libelle: string;
  activite_id: number;
  activite_libelle: string;
  devise_id: number;
  devise_monnaie: string;
  devise_code_iso: string;
  code_article_id: number;
  code_article_libelle: string;
  client_id: number;
  client_libelle: string;
  pays_id: number;
  pays_libelle: string;
  bu_id: number;
  bu_libelle: string;
  has_saisie: boolean;
  tarif_id?: number;
  tarifheure?: string;
  tarifacte?: string;
  couts_id?: number;
  coutactivite?: string;
  tar_date_debut?: Date;
  couts_date_debut?: Date;
  couts_date_fin?: Date;
  tar_date_fin?: Date;
  tar_parent_id?: number;
  couts_parent_id?: number;
  date_first_facturation: string;
}
export interface IUserRef {
  id: number
  name: string
  email: string
  prenom: string
}

export interface DatasArticle {
  firstNiveau: FirstNiveau;
  secondNiveau: SecondNiveau[];
}

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;
const Article = () => {
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const { isDesktopOrLaptop } = useContext(MediaQueryContext);

  const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  //Redux
  const articleInfo = useSelector<Reducers>(
    (state) => state.articleParm
  ) as ArticleInformation;

  // Search
  const [idSocieteSearch, setIdSocieteSearch] = useState<string>(
    CheckAttr(articleInfo) ? String(articleInfo?.idSociete) : ""
  );

  const [idCodeGescoSearch, setIdCodeGescoSearch] = useState<string>(
    CheckAttr(articleInfo) ? String(articleInfo?.idCodeGesco) : ""
  );

  const [idOperationSearch, setIdOperationSearch] = useState<string>(
    CheckAttr(articleInfo) ? String(articleInfo?.idOPeration) : ""
  );

  const [libelleSearch, setLibelleSearch] = useState<string>("");

  // All Ref
  const [allUserGRCCommerciaux, setAllUserGRCCommerciaux] = useState<IUserRef[]>([]);
  const [alltype, setAllType] = useState<DataRef[]>([]);
  const [allActivite, setAllActive] = useState<DataRef[]>([]);
  const [allDevise, setAllDevise] = useState<DeviseInterface[]>([]);
  const [allSocieteFacturation, setallSocieteFacturation] = useState<DataRef[]>(
    []
  );
  const [allOperationHasArticle, setAllOperationHasArticle] = useState<
    DataRef[]
  >([]);
  const [allCodeGesco, setAllCodeGesco] = useState<DataRef[]>([]);
  const [allClientWithChild, setAllClientWithChild] = useState<
    ClientWithChildInterface[]
  >([]);

  //Modal
  const [openModal, setOpenModal] = useState<boolean>(false);

  // Page
  const [page, setPage] = useState<number>(1);
  const [rowPerPage, setRowPerPage] = useState(5);
  const [totalNumber, setTotalNumber] = useState(0);
  const [loader, setLoader] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<number | false>(false);

  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [alertType, setAlertType] = useState<AlertType>("success");

  // Data
  const [datasArticle, setDatasArticle] = useState<DatasArticle[]>([]);

  // Ref
  const [dataRefPaysBu, setDataRefPaysBu] = useState<IPays[]>([]);

  // collone
  const [sortedColumn, setSortedColumn] = useState<number>(0);
  const [columnToSort, setColumnToSort] = useState<SortParams | undefined>(undefined);

  const setSortParams = (column: string, order: SortType) => {
    setColumnToSort({
      column,
      orderBy: order,
    });
  };

  const iconToUse = (id: number): JSX.Element => {
    let icon = <ArrowUpwardIcon sx={{ fontSize: 13, marginRight: 1 }} />;
    if (sortedColumn === id) {
      if (columnToSort && columnToSort.orderBy === "DESC") {
        icon = <ArrowDownwardIcon sx={{ fontSize: 13, marginRight: 1 }} />;
      }
    }

    return icon;
  };

  // Effect
  useEffect(() => {
    getAllArticle();
  }, [
    page,
    rowPerPage,
    idSocieteSearch,
    idCodeGescoSearch,
    idOperationSearch,
    columnToSort,
    refresh,
  ]);

  // Modal
  const handleClose = () => {
    setOpenModal(false);
  };

  // Get
  const getAllArticle = () => {
    setLoader(true);

    const data = {
      rowPerPage,
      page,
      article: libelleSearch,
      operation: idOperationSearch != '' ? idOperationSearch : null,
      societeFacturation: idSocieteSearch != '' ? idSocieteSearch : null,
      codeGesco: idCodeGescoSearch != '' ? idCodeGescoSearch : null,
      sortby: CheckAttr(columnToSort) && columnToSort,
    };

    http
      .post("article/list", data)
      .then((res) => {
        const { total, datas } = res.data;
        setDatasArticle(datas);
        setTotalNumber(total);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getRefPaysBu = () => {
    // Get Ref Pays With Bu Pour Ajout et Modifier
    axios
      .get(`${urlApi}allpaysbu`)
      .then((res) => {
        setDataRefPaysBu(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // RereshArticle
  const RereshDataArticle = () => {
    getAllArticle();
  };

  // Get data Reg
  const getDataRef = () => {
    let loadeTempType = true;
    // Type
    http
      .get(`getalltype`)
      .then((res) => {
        Array.isArray(res.data) && setAllType(res.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => (loadeTempType = false));

    // Devise
    http
      .get(`getalldevise`)
      .then((res) => {
        Array.isArray(res.data) && setAllDevise(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // Activite
    http
      .get(`getallactivite`)
      .then((res) => {
        Array.isArray(res.data) && setAllActive(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // All Societe de Facturation
    http
      .get(`societe-facturation/find/all`)
      .then((res) => {
        Array.isArray(res.data) && setallSocieteFacturation(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // All Client With Child
    http
      .get(`client/get/all/withchild`)
      .then((res) => {
        Array.isArray(res.data) && setAllClientWithChild(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
    // All User Profil GRC Commerciaux
    http
      .get(`user/grc-commerciaux`)
      .then((res) => {
        Array.isArray(res.data) && setAllUserGRCCommerciaux(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const dispatch = useDispatch();

  const navigate = useNavigate();


  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove('jwt', { path: '/' });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  const handleRefresh = () => {
    // Suppremer l Article Info Dans Redux
    dispatch(deleteArticleInformationParam());

    window.location.reload();
  };

  const reloadList = () => {
    setRefresh(!refresh);
  };

  const ClickSearch = () => {
    setPage(1);
    getAllArticle();
  };

  useEffect(() => {
    // Get All Code Gesco
    idSocieteSearch &&
      http
        .get(`code-gesco/findby/societe-facturation/${idSocieteSearch}`)
        .then((res) => {
          Array.isArray(res.data) && setAllCodeGesco(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
  }, [idSocieteSearch]);

  useEffect(() => {
    // Get All Code Operation
    idSocieteSearch &&
      idCodeGescoSearch &&
      http
        .get(
          `operation/viasociete/codegesco/${idSocieteSearch}/${idCodeGescoSearch}`
        )
        .then((res) => {
          Array.isArray(res.data) && setAllOperationHasArticle(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
  }, [idCodeGescoSearch]);

  useEffect(() => {
    getRefPaysBu();
    getDataRef();
  }, []);

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const handleChangeSocifact = (e: any) => {
    setIdSocieteSearch(e.target.value as string);
    setIdCodeGescoSearch("");
    setIdOperationSearch("");
    setPage(1);
  }

  const handleChangeCodeGesco = (e: any) => {
    setIdCodeGescoSearch(e.target.value as string);
    setIdOperationSearch("");
    setPage(1);
  }

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  const theme = createTheme({
    palette: {
      primary: {
        main: '#FC8404',
        contrastText: '#EEE'
      },
      secondary: {
        main: '#EEE'
      }

    },
  });

  const pagination: JSX.Element | boolean = !loader && (
    <Stack spacing={2} direction="row">
      <InputLabel sx={{ color: "#fff" }}>Lignes par page :</InputLabel>
      <FormControl variant="standard" sx={{ minWidth: 50 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          color="warning"
          sx={{ background: "#fff", borderRadius: 1, paddingLeft: 1 }}
          value={rowPerPage}
          onChange={(e) => {
            setRowPerPage(e.target.value as number);
            setPage(1);
          }}
          defaultValue={5}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      {totalNumber > rowPerPage && (
        <ThemeProvider theme={theme}>
          <Pagination
            count={Math.ceil(totalNumber / rowPerPage)}
            color="primary"
            sx={{ button: { color: "#fff" } }}
            showFirstButton={true}
            showLastButton={true}
            siblingCount={0}
            boundaryCount={1}
            defaultPage={page}
            onChange={(event, value) => setPage(value)}
          />
        </ThemeProvider>
      )}
    </Stack>
  );

  return (
    <>
      <Container maxWidth="xl">
        {isDesktopOrLaptop ? (
          <>
            <Grid container spacing={0.5} columns={{ xs: 6, sm: 10, md: 12 }}>
              <Grid item xs={6} sm={2} md={3}>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  color="warning"
                  sx={{ textTransform: "none" }}
                  onClick={() => setOpenModal(true)}
                >
                  Ajouter
                </Button>
              </Grid>
              <Grid item xs={3} sm={1.75} md={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                    shrink={CheckAttr(idSocieteSearch)}
                  >
                    Societe De Facturation
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="pays"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="pays"
                    value={idSocieteSearch}
                    onChange={handleChangeSocifact}
                  >
                    <MenuItem value={0}></MenuItem>
                    {allSocieteFacturation.map((item) => {
                      return <MenuItem value={item.id}>{item.libelle}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={1.75} md={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                    shrink={CheckAttr(idCodeGescoSearch)}
                  >
                    Code Gesco
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="pays"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="pays"
                    value={idCodeGescoSearch}
                    onChange={(e) => {
                      setIdCodeGescoSearch(e.target.value as string);
                      setIdOperationSearch("");
                      setPage(1);
                    }}
                  >
                    <MenuItem value={0}></MenuItem>
                    {allCodeGesco.map((item) => {
                      return <MenuItem value={item.id}>{item.libelle}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={1.75} md={2}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                    shrink={CheckAttr(idOperationSearch)}
                  >
                    Operation
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="filter"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Age"
                    value={idOperationSearch}
                    onChange={(e) => {
                      setIdOperationSearch(e.target.value as string);
                    }}
                  >
                    <MenuItem value={0}></MenuItem>
                    {allOperationHasArticle.map((item) => {
                      return <MenuItem value={item.id}>{item.libelle}</MenuItem>;
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4} sm={2.5} md={2.5}>
                <Stack
                  direction="row"
                  spacing={3}
                  display="flex"
                  ml={3}
                  justifyContent="end"
                >
                  <InputBase
                    sx={{ ml: 4, flex: 1, color: "white" }}
                    value={libelleSearch}
                    placeholder="Chercher un article"
                    onChange={(e) => setLibelleSearch(e.target.value)}
                    fullWidth
                  />
                  <IconButton
                    type="submit"
                    sx={{ p: "10px", color: "white" }}
                    aria-label="search"
                    onClick={ClickSearch}
                  >
                    <SearchIcon />
                  </IconButton>
                </Stack>
              </Grid>
              <Grid item xs={1} sm={1.5} md={0.5}>
                <IconButton
                  aria-label="refresh"
                  sx={{ color: "#fff", pt: 0.5 }}
                  onClick={() => handleRefresh()}
                >
                  <RefreshIcon sx={{ fontSize: 35 }} />
                </IconButton>
              </Grid>
            </Grid>

            <Box
              mt={4}
              mb={0.5}
              sx={{
                display: "flex",
                justifyContent: { sm: "center", md: "left" },
              }}
            >
              {pagination}
            </Box>

            <TableContainer component={Paper} style={tableStyle}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell />
                    {tableColumnTittlesArticle.map((column) => (
                      <TabSort
                        key={column.id}
                        column={column}
                        icon={iconToUse(column.id)}
                        sortedColumn={sortedColumn}
                        setSortParams={setSortParams}
                        setSortedColumn={setSortedColumn}
                      />
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {datasArticle.map((row, index) => (
                    <ArticleRow
                      key={index}
                      isDesktopOrLaptop={isDesktopOrLaptop}
                      row={row}
                      allActivite={allActivite}
                      allDevise={allDevise}
                      alltype={alltype}
                      dataRefPaysBu={dataRefPaysBu}
                      allClientWithChild={allClientWithChild}
                      RereshDataArticle={RereshDataArticle}
                      http={http}
                      reloadList={reloadList}
                      setAlertType={setAlertType}
                      setAlerteMessage={setAlerteMessage}
                      setOpenSnack={setOpenSnack}
                      expanded={expanded}
                      setExpanded={setExpanded}
                      allUserGRCCommerciaux={allUserGRCCommerciaux}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              mt={4}
              sx={{
                display: "flex",
                justifyContent: { sm: "center", md: "right" },
              }}
            >
              {pagination}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{
              position: 'fixed',
              width: '95%',
              top: '10.32rem',
              pr: 1.5,
              pt: 2,
              bgcolor: '#080d24',
              zIndex: 1000
            }}>
              <Button
                variant="contained"
                size='small'
                startIcon={<AddIcon />}
                color="warning"
                fullWidth
                sx={{
                  textTransform: "none",
                  mb: 2
                }}
                onClick={() => setOpenModal(true)}
              >
                Ajouter
              </Button>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  Filtre
                </AccordionSummary>
                <AccordionDetails>
                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      color="warning"
                      sx={{ mt: -1 }}
                    >
                      {!CheckAttr(idSocieteSearch) && "Societe De Facturation"}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Societe De Facturation"
                      value={idSocieteSearch}
                      onChange={handleChangeSocifact}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {allSocieteFacturation.map((item) => (
                        <MenuItem key={item?.id} value={item?.id} dense>
                          {item?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      color="warning"
                      sx={{ mt: -1 }}
                    >
                      {!CheckAttr(idCodeGescoSearch) && "Code Gesco"}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Code Gesco"
                      value={idCodeGescoSearch}
                      onChange={handleChangeCodeGesco}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {allCodeGesco.map((item) => (
                        <MenuItem key={item?.id} value={item?.id} dense>
                          {item?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      color="warning"
                      sx={{ mt: -1 }}
                    >
                      {!CheckAttr(idOperationSearch) && "Opération"}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Code Gesco"
                      value={idOperationSearch}
                      onChange={(e) => setIdOperationSearch(e.target.value as string)}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {allOperationHasArticle.map((item) => (
                        <MenuItem key={item?.id} value={item?.id} dense>
                          {item?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </AccordionDetails>
              </Accordion>

              <TextField
                id="outlined-basic"
                variant="outlined"
                sx={{
                  bgcolor: '#fff',
                  borderRadius: 1,
                  mt: 1
                }}
                placeholder="Chercher un article ..."
                size="small"
                fullWidth
                value={libelleSearch}
                onChange={(e) => setLibelleSearch(e.target.value)}
                color="warning"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        aria-label="search"
                        onClick={() => ClickSearch()}
                      >
                        <SearchIcon />
                      </IconButton>
                      <IconButton
                        aria-label="directions"
                        onClick={() => handleRefresh()}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Box mt={2}>
                <Typography>Liste des articles</Typography>
                <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 3 }} />

                {(!loader && (totalNumber > rowPerPage)) && (
                  <Box display="flex" justifyContent="end">
                    <Pagination
                      count={Math.ceil(totalNumber / rowPerPage)}
                      size="small"
                      color="standard"
                      sx={{ button: { color: "white" }, mb: 2 }}
                      showFirstButton={true}
                      showLastButton={true}
                      siblingCount={0}
                      boundaryCount={1}
                      defaultPage={page}
                      onChange={(event, value) => setPage(value)}
                    />
                  </Box>)}
              </Box>
            </Box>

            <Box mt='16rem'>
              {datasArticle.map(row => (
                <ArticleRow
                  key={row?.firstNiveau?.pivot_oper_socifact_id}
                  isDesktopOrLaptop={isDesktopOrLaptop}
                  row={row}
                  allActivite={allActivite}
                  allDevise={allDevise}
                  alltype={alltype}
                  dataRefPaysBu={dataRefPaysBu}
                  allClientWithChild={allClientWithChild}
                  RereshDataArticle={RereshDataArticle}
                  http={http}
                  reloadList={reloadList}
                  setAlertType={setAlertType}
                  setAlerteMessage={setAlerteMessage}
                  setOpenSnack={setOpenSnack}
                  expanded={expanded}
                  setExpanded={setExpanded}
                  allUserGRCCommerciaux={allUserGRCCommerciaux}
                />
              ))}
            </Box>

            <Stack direction="row" sx={{ mt: 3, mb: 4 }}>
              <InputLabel sx={{ color: "#fff", fontSize: 12, mt: 0.5 }}>Lignes par page :</InputLabel>
              <FormControl variant="standard" sx={{ minWidth: 48 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  color="warning"
                  sx={{
                    background: "#fff",
                    borderRadius: 1,
                    paddingLeft: 1,
                    paddingTop: 0.5,
                    marginLeft: 1,
                    fontSize: 12
                  }}
                  value={rowPerPage}
                  onChange={(e) => setRowPerPage(e.target.value as number)}
                  defaultValue={5}
                  size="small"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </>
        )}

      </Container>
      <OptionalWidthModal
        title="Ajouter un Article"
        breackPoint="md"
        onClose={handleClose}
        open={openModal}
      >
        <ArticleForm
          dataRefPaysBu={dataRefPaysBu}
          allActivite={allActivite}
          allDevise={allDevise}
          alltype={alltype}
          onClose={handleClose}
          allClientWithChild={allClientWithChild}
          reloadList={reloadList}
          allUserGRCCommerciaux={allUserGRCCommerciaux}
        />
      </OptionalWidthModal>
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

      {stackAlert}
    </>
  );
};

export default Article;
